// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__19Jqg","consentsList":"PatientConsents_consentsList__3ptPx","consentsListEmpty":"PatientConsents_consentsListEmpty__SCaee"};